// extracted by mini-css-extract-plugin
export default {"list":"Menu_list__ZHKgw","listItem":"Menu_listItem__mkVjH","popup":"Menu_popup__lMO7L","popupContent":"Menu_popupContent__CmDWe"};